import { render, staticRenderFns } from "./Nova.vue?vue&type=template&id=27acbac6&"
import script from "./Nova.vue?vue&type=script&lang=js&"
export * from "./Nova.vue?vue&type=script&lang=js&"
import style0 from "./Nova.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports